import { Skeleton } from "@/atoms"

export const Fallback = () => <Skeleton active />
